import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalType } from '../types/Modal';
import { Session } from '../types/Session';
import { DialogFormProps, ModalPropsWrapper } from 'src/components/shared/Modals';
import { ConfirmationProps, ConfirmationPropsWrapper } from 'src/components/shared/Modals/ConfirmationModal';
import { DocumentResultsProps, DocumentResultsPropsWrapper } from 'src/components/shared/Modals/DocumentResultsModal';
import { AssetsAgentProps, AssetsAgentPropsWrapper } from 'src/components/shared/Modals/AssetsAgentModal';
import { DocumentRetrieversProps, DocumentRetrieversPropsWrapper } from 'src/components/shared/Modals/DocumentRetrieversModal';

export enum State {
    IDLE = 'IDLE',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
}

export enum DataStates {
    AGENT = 'AGENT',
    AGENT_ASSET = 'AGENT_ASSET',
    DOCUMENT = 'DOCUMENT',
    RETRIEVER = 'RETRIEVER'
}

export interface AppState {
    session: Session;
    loading: {
        [key in DataStates]: State;
    },
    modal: {
        [ModalType.DYNAMIC]?: DialogFormProps<any> | false;
        [ModalType.CONFIRMATION]?: ConfirmationProps | false;
        [ModalType.DOCUMENT_RESULTS]?: DocumentResultsProps | false;
        [ModalType.ASSETS_AGENT]?: AssetsAgentProps | false;
        [ModalType.DOCUMENT_RETRIEVERS]?: DocumentRetrieversProps | false;
    }
}

export const initialState: AppState = {
    session: new Session(),
    loading: {
        [DataStates.AGENT]: State.IDLE,
        [DataStates.AGENT_ASSET]: State.IDLE,
        [DataStates.DOCUMENT]: State.IDLE,
        [DataStates.RETRIEVER]: State.IDLE
    },
    modal: {},
};

type ModalWrapperProps =
    | ModalPropsWrapper
    | ConfirmationPropsWrapper
    | DocumentResultsPropsWrapper
    | AssetsAgentPropsWrapper
    | DocumentRetrieversPropsWrapper;

const { reducer, actions } = createSlice({
    name: 'app',
    initialState,
    reducers: {
        openModal(state, { payload: { type, data } }: PayloadAction<ModalWrapperProps>) {
            state.modal = { ...state.modal, [type]: data };
        },
        closeModal(state, action: PayloadAction<ModalType>) {
            state.modal[action.payload] = false;
        },
        closeAllModals(state) {
            state.modal = initialState.modal;
        },
        onLoading(state, { payload: { type, status } }: PayloadAction<{ type: DataStates, status: State }>) {
            state.loading[type] = status;
        },
    },
});

export const appActions = actions;
export default reducer;